import { Component } from '@angular/core';
import { BaseModalDirective } from '../base-modal';
declare let gtag: Function;

@Component({
    selector: 'nh-confirm-appeal-resp',
    templateUrl: './confirm-appeal-resp.component.html',
    styleUrls: ['./confirm-appeal-resp.component.scss'],
    standalone: false
})
export class ConfirmAppealRespComponent extends BaseModalDirective {
  checkboxChecked = false;
  submittedAuthRepFormAckSw = false;
  nonSubmittedAuthRepFormAckSw = false;
  onCheckboxChange(event: any): void {
    this.checkboxChecked = event.target.checked;
  }

  isConfirmDisabled(): boolean {
    return !(this.submittedAuthRepFormAckSw || this.nonSubmittedAuthRepFormAckSw);
  }
  onChangeAuthAppellantAck(checkboxValue, event) {
    const checked = event.target.checked;
    if (checkboxValue === 'ARASW' && checked) {
      this.submittedAuthRepFormAckSw = true
      this.nonSubmittedAuthRepFormAckSw = false;
    }
    else {
      this.submittedAuthRepFormAckSw = false;
    }
    if (checkboxValue === 'NARASW' && checked) {
      this.nonSubmittedAuthRepFormAckSw = true;
      this.submittedAuthRepFormAckSw = false;
    }
    else {
      this.nonSubmittedAuthRepFormAckSw = false;
    }
    if (this.submittedAuthRepFormAckSw) {
      sessionStorage.setItem('submittedAuthRepFormAckSw', "Y");
    }
    else {
      sessionStorage.setItem('submittedAuthRepFormAckSw', "N");
    }
    if (this.nonSubmittedAuthRepFormAckSw) {
      sessionStorage.setItem('nonSubmittedAuthRepFormAckSw', "Y");
    }
    else {
      sessionStorage.setItem('nonSubmittedAuthRepFormAckSw', "N");
    }
  }
  
  onDesc1LinkClick(event: MouseEvent): void {
    const linkText = (event.target as HTMLElement).closest('a');
    const id = linkText?.getAttribute('data-link-id');
    if (id === 'Organization') {
      gtag('event', 'auth_repre_org_click', {
        'event_category': 'Authorized Representative - Organization',
        'event_label': 'Authorized Representative - Organization'
      });
    }
    else if (id === 'Individual') {      
      gtag('event', 'auth_repre_indiv_click', {
        'event_category': 'Authorized Representative - Individual',
        'event_label': 'Authorized Representative - Individual'
      });
    }
  }
}
